import { ConsentBanner } from "./ConsentBanner";
import { ConsentPreferences } from "./ConsentPreferences";

// The always-mounted consent surface: the first-run banner plus the preferences
// dialog (reopened from the persistent privacy-settings control). Rendered
// inside HeroUIProvider so the modal has overlay/theme context.
export function ConsentGate() {
  return (
    <>
      <ConsentBanner />
      <ConsentPreferences />
    </>
  );
}
